export enum PricingFilterValues {
  ALL = '',
  FREE = 'true',
  PREMIUM = 'false',
}
